import type { ThemeConfig } from "antd";

export const xconsTheme: ThemeConfig = {
  // xcons.1: "#e9f4ef",
  // xcons.2: "#dae8e0",
  // xcons.3: "#abdbc1",
  // xcons.4: "#468c69",
  // xcons.5: "#2b8058",
  // xcons.6: "#15744b",
  // xcons.7: "#0a4d32",
  // xcons.8: "#053e29",
  // xcons.9: "#032619",
  // xcons.10: "#011d13"
  token: {
    colorText: "rgba(0, 0, 0, 0.88)",
    colorTextSecondary: "rgba(0, 0, 0, 0.65)",
    colorTextTertiary: "rgba(0, 0, 0, 0.45)",
    colorTextQuaternary: "rgba(0, 0, 0, 0.25)",
    colorTextLightSolid: "#ffffff",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextLabel: "rgba(0, 0, 0, 0.65)",
    colorTextDescription: "rgba(0, 0, 0, 0.45)",
    colorTextDisabled: "rgba(0, 0, 0, 0.25)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
    colorIcon: "rgba(0, 0, 0, 0.45)",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorBgLayout: "#f5f5f5",
    colorBgMask: "rgba(0, 0, 0, 0.45)",
    colorBgSpotlight: "rgba(0, 0, 0, 0.85)",
    colorBorder: "#d9d9d9",
    colorBorderSecondary: "#f0f0f0",
    colorFill: "rgba(0, 0, 0, 0.15)",
    colorFillSecondary: "rgba(0, 0, 0, 0.06)",
    colorFillTertiary: "rgba(0, 0, 0, 0.04)",
    colorFillQuaternary: "rgba(0, 0, 0, 0.02)",
    colorWhite: "#ffffff",
    colorBgBase: "#ffffff",
    colorTextBase: "#000000",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgTextActive: "rgba(0, 0, 0, 0.15)",
    colorBgTextHover: "rgba(0, 0, 0, 0.06)",
    colorBorderBg: "#ffffff",
    colorFillContent: "rgba(0, 0, 0, 0.06)",
    colorFillContentHover: "rgba(0, 0, 0, 0.15)",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimary: "#15744b",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorInfo: "#15744b",
    colorError: "#ff4d4f",
    colorLink: "#15744b",
    colorErrorBg: "#fff2f0",
    colorErrorBgHover: "#fff1f0",
    colorErrorBorder: "#ffccc7",
    colorErrorBorderHover: "#ffa39e",
    colorErrorHover: "#ff7875",
    colorErrorActive: "#d9363e",
    colorErrorTextHover: "#ff7875",
    colorErrorText: "#ff4d4f",
    colorErrorTextActive: "#d9363e",
    colorLinkHover: "#2b8058",
    colorInfoBg: "#e9f4ef",
    colorInfoBgHover: "#dae8e0",
    colorInfoBorder: "#abdbc1",
    colorInfoBorderHover: "#468c69",
    colorInfoHover: "#2b8058",
    colorInfoActive: "#0a4d32",
    colorInfoTextHover: "#2b8058",
    colorInfoText: "#15744b",
    colorInfoTextActive: "#0a4d32",
    colorLinkActive: "#0a4d32",
    colorPrimaryBg: "#e9f4ef",
    colorPrimaryBgHover: "#dae8e0",
    colorPrimaryBorder: "#abdbc1",
    colorPrimaryBorderHover: "#468c69",
    colorPrimaryHover: "#2b8058",
    colorPrimaryActive: "#0a4d32",
    colorPrimaryTextHover: "#2b8058",
    colorPrimaryText: "#15744b",
    colorPrimaryTextActive: "#0a4d32",
    colorSuccessBg: "#f6ffed",
    colorSuccessBgHover: "#d9f7be",
    colorSuccessBorder: "#b7eb8f",
    colorSuccessBorderHover: "#95de64",
    colorSuccessHover: "#95de64",
    colorSuccessActive: "#389e0d",
    colorSuccessTextHover: "#73d13d",
    colorSuccessText: "#52c41a",
    colorSuccessTextActive: "#389e0d",
    colorWarningBg: "#fffbe6",
    colorWarningBgHover: "#fff1b8",
    colorWarningBorder: "#ffe58f",
    colorWarningBorderHover: "#ffd666",
    colorWarningHover: "#ffd666",
    colorWarningActive: "#d48806",
    colorWarningTextHover: "#ffc53d",
    colorWarningText: "#faad14",
    colorWarningTextActive: "#d48806",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    controlItemBgActive: "#e9f4ef",
    controlItemBgActiveDisabled: "rgba(0, 0, 0, 0.15)",
    controlItemBgActiveHover: "#dae8e0",
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlOutline: "rgba(5, 145, 255, 0.1)",
    controlTmpOutline: "rgba(0, 0, 0, 0.02)",
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    borderRadiusXS: 2,
    sizeStep: 4,
    sizeUnit: 4,
    controlInteractiveSize: 16,
    size: 16,
    sizeLG: 24,
    sizeMD: 20,
    sizeMS: 16,
    sizeSM: 12,
    sizeXL: 32,
    sizeXS: 8,
    sizeXXL: 48,
    controlHeight: 32,
    sizeXXS: 4,
    controlHeightLG: 40,
    controlHeightSM: 24,
    controlHeightXS: 16,
    lineWidth: 1,
    lineWidthBold: 2,
    lineWidthFocus: 4,
    controlOutlineWidth: 2,
    screenLG: 992,
    screenLGMax: 1199,
    screenLGMin: 992,
    screenMD: 768,
    screenMDMax: 991,
    screenMDMin: 768,
    screenSM: 576,
    screenSMMax: 767,
    screenSMMin: 576,
    screenXL: 1200,
    screenXLMax: 1599,
    screenXLMin: 1200,
    screenXS: 480,
    screenXSMax: 575,
    screenXSMin: 480,
    screenXXL: 1600,
    screenXXLMin: 1600,
    sizePopupArrow: 16,
    margin: 16,
    marginLG: 24,
    marginMD: 20,
    marginSM: 12,
    marginXL: 32,
    marginXS: 8,
    marginXXL: 48,
    marginXXS: 4,
    padding: 16,
    paddingLG: 24,
    paddingMD: 20,
    paddingSM: 12,
    paddingXL: 32,
    paddingXS: 8,
    paddingXXS: 4,
    paddingContentHorizontal: 16,
    paddingContentHorizontalLG: 24,
    paddingContentHorizontalSM: 16,
    paddingContentVertical: 12,
    paddingContentVerticalLG: 16,
    paddingContentVerticalSM: 8,
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
    fontFamilyCode: "Courier Prime",
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeSM: 12,
    fontSizeXL: 20,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    lineHeight: 1.5714285714285714,
    lineHeightHeading1: 1.2105263157894737,
    lineHeightHeading2: 1.2666666666666666,
    lineHeightHeading3: 1.3333333333333333,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.5,
    lineHeightLG: 1.5,
    lineHeightSM: 1.6666666666666667,
    fontSizeIcon: 12,
    fontWeightStrong: 600,
  },
  components: {
    Input: {
      paddingInlineSM: 7,
      paddingInlineLG: 11,
      paddingInline: 11,
      paddingBlockSM: 0,
      paddingBlockLG: 7,
      paddingBlock: 4,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      lineWidth: 1,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSize: 14,
      controlPaddingHorizontalSM: 8,
      controlPaddingHorizontal: 12,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWarningOutline: "rgba(255, 215, 5, 0.1)",
      colorWarningBorderHover: "#ffd666",
      colorWarning: "#faad14",
      colorTextTertiary: "rgba(0, 0, 0, 0.45)",
      colorTextQuaternary: "rgba(0, 0, 0, 0.25)",
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimary: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorErrorOutline: "rgba(255, 38, 6, 0.06)",
      colorErrorBorderHover: "#ffa39e",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      hoverBorderColor: "#2b8058",
      addonBg: "rgba(0, 0, 0, 0.02)",
      activeBorderColor: "#15744b",
      colorFillTertiary: "rgba(0, 0, 0, 0.04)",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorErrorBgHover: "#fff1f0",
      colorErrorBg: "#fff2f0",
      colorWarningBg: "#fffbe6",
      colorWarningBgHover: "#fff1b8",
      colorWarningText: "#faad14",
      colorErrorText: "#ff4d4f",
      activeBg: "#ffffff",
      hoverBg: "#ffffff",
      inputFontSize: 14,
      inputFontSizeLG: 16,
      inputFontSizeSM: 12,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Transfer: {
      listWidthLG: 250,
      listWidth: 180,
      listHeight: 200,
      itemPaddingBlock: 5,
      paddingXS: 8,
      paddingSM: 12,
      marginXXS: 4,
      marginXS: 8,
      margin: 16,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeIcon: 12,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActiveHover: "#dae8e0",
      controlItemBgActive: "#e9f4ef",
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusLG: 8,
      colorWarning: "#faad14",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorLinkHover: "#2b8058",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      itemHeight: 32,
      headerHeight: 40,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Segmented: {
      paddingXXS: 4,
      marginSM: 12,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlPaddingHorizontalSM: 8,
      controlPaddingHorizontal: 12,
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorTextLabel: "rgba(0, 0, 0, 0.65)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorFill: "rgba(0, 0, 0, 0.15)",
      colorBgLayout: "#f5f5f5",
      colorBgElevated: "#ffffff",
      itemSelectedColor: "rgba(0, 0, 0, 0.88)",
      itemSelectedBg: "#ffffff",
      itemHoverColor: "rgba(0, 0, 0, 0.88)",
      itemHoverBg: "rgba(0, 0, 0, 0.06)",
      itemColor: "rgba(0, 0, 0, 0.65)",
      itemActiveBg: "rgba(0, 0, 0, 0.15)",
      trackPadding: 2,
      trackBg: "#f5f5f5",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Switch: {
      trackPadding: 2,
      trackMinWidthSM: 28,
      trackMinWidth: 44,
      trackHeightSM: 16,
      trackHeight: 22,
      handleSizeSM: 12,
      handleSize: 18,
      marginXXS: 4,
      lineWidthFocus: 4,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSizeIcon: 12,
      fontSize: 14,
      controlHeight: 32,
      colorWhite: "#ffffff",
      colorTextTertiary: "rgba(0, 0, 0, 0.45)",
      colorTextQuaternary: "rgba(0, 0, 0, 0.25)",
      colorTextLightSolid: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      handleBg: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Timeline: {
      itemPaddingBottom: 20,
      paddingXXS: 4,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      marginSM: 12,
      margin: 16,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSize: 14,
      controlHeightLG: 40,
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorPrimary: "#15744b",
      colorError: "#ff4d4f",
      colorBgContainer: "#ffffff",
      tailColor: "rgba(0, 0, 0, 0.06)",
      dotBg: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Tabs: {
      horizontalItemGutter: 32,
      cardGutter: 2,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      marginSM: 12,
      margin: 16,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimaryActive: "#0a4d32",
      colorPrimary: "#15744b",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorBorderSecondary: "#f0f0f0",
      colorBorder: "#d9d9d9",
      colorBgContainer: "#ffffff",
      itemSelectedColor: "#15744b",
      itemHoverColor: "#2b8058",
      itemColor: "rgba(0, 0, 0, 0.88)",
      itemActiveColor: "#0a4d32",
      inkBarColor: "#15744b",
      cardHeight: 40,
      cardBg: "rgba(0, 0, 0, 0.02)",
      titleFontSize: 14,
      titleFontSizeLG: 16,
      titleFontSizeSM: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Table: {
      stickyScrollBarBorderRadius: 100,
      headerSplitColor: "#f0f0f0",
      headerBg: "rgba(0, 0, 0, 0.02)",
      footerBg: "rgba(0, 0, 0, 0.02)",
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      padding: 16,
      marginXXS: 4,
      margin: 16,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeSM: 12,
      fontSizeIcon: 12,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActiveHover: "#dae8e0",
      controlItemBgActive: "#e9f4ef",
      controlInteractiveSize: 16,
      controlHeight: 32,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimary: "#15744b",
      colorLinkHover: "#2b8058",
      colorLinkActive: "#0a4d32",
      colorLink: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorFillContent: "rgba(0, 0, 0, 0.06)",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorBorderSecondary: "#f0f0f0",
      colorBgContainer: "#ffffff",
      rowSelectedHoverBg: "#dae8e0",
      headerFilterHoverBg: "rgba(0, 0, 0, 0.06)",
      headerColor: "rgba(0, 0, 0, 0.88)",
      headerBorderRadius: 8,
      footerColor: "rgba(0, 0, 0, 0.88)",
      filterDropdownMenuBg: "#ffffff",
      filterDropdownBg: "#ffffff",
      cellPaddingInlineSM: 8,
      cellPaddingInlineMD: 8,
      cellPaddingInline: 16,
      cellPaddingBlockSM: 8,
      cellPaddingBlockMD: 12,
      cellPaddingBlock: 16,
      borderColor: "#f0f0f0",
      rowHoverBg: "#fafafa",
      headerSortActiveBg: "rgba(0, 0, 0, 0.06)",
      bodySortBg: "#fafafa",
      headerSortHoverBg: "rgba(0, 0, 0, 0.06)",
      cellFontSize: 14,
      cellFontSizeMD: 14,
      cellFontSizeSM: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Steps: {
      dotSize: 8,
      dotCurrentSize: 10,
      descriptionMaxWidth: 140,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      marginSM: 12,
      marginLG: 24,
      margin: 16,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeightSM: 1.6666666666666667,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSizeHeading3: 24,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlHeightLG: 40,
      borderRadiusSM: 4,
      colorTextQuaternary: "rgba(0, 0, 0, 0.25)",
      colorTextLightSolid: "#ffffff",
      colorTextLabel: "rgba(0, 0, 0, 0.65)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorFillContent: "rgba(0, 0, 0, 0.06)",
      colorError: "#ff4d4f",
      colorBorderSecondary: "#f0f0f0",
      colorBorderBg: "#ffffff",
      colorBgContainer: "#ffffff",
      titleLineHeight: 32,
      iconSizeSM: 24,
      iconSize: 32,
      customIconFontSize: 24,
      iconFontSize: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Spin: {
      dotSizeSM: 14,
      dotSize: 20,
      contentHeight: 400,
      marginXXS: 4,
      lineHeight: 1.5714285714285714,
      fontSize: 14,
      controlHeightLG: 40,
      controlHeight: 32,
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimary: "#15744b",
      colorBgContainer: "#ffffff",
      dotSizeLG: 32,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Slider: {
      railSize: 4,
      handleSizeHover: 12,
      dotSize: 8,
      controlSize: 10,
      handleSize: 10,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSize: 14,
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusXS: 2,
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryBorderHover: "#468c69",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorFillTertiary: "rgba(0, 0, 0, 0.04)",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorFillContentHover: "rgba(0, 0, 0, 0.15)",
      colorBorderSecondary: "#f0f0f0",
      colorBgElevated: "#ffffff",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      trackHoverBg: "#468c69",
      trackBgDisabled: "rgba(0, 0, 0, 0.04)",
      trackBg: "#abdbc1",
      railHoverBg: "rgba(0, 0, 0, 0.06)",
      railBg: "rgba(0, 0, 0, 0.04)",
      handleColor: "#abdbc1",
      handleActiveColor: "#15744b",
      dotBorderColor: "#f0f0f0",
      dotActiveBorderColor: "#abdbc1",
      handleColorDisabled: "#bfbfbf",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Rate: {
      marginXS: 8,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSize: 14,
      controlHeightLG: 40,
      colorText: "rgba(0, 0, 0, 0.88)",
      colorFillContent: "rgba(0, 0, 0, 0.06)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Radio: {
      radioSize: 16,
      dotSize: 8,
      buttonPaddingInline: 15,
      paddingXS: 8,
      padding: 16,
      marginXS: 8,
      lineWidthFocus: 4,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlItemBgActiveDisabled: "rgba(0, 0, 0, 0.15)",
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWhite: "#ffffff",
      colorTextLightSolid: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimaryActive: "#0a4d32",
      colorPrimary: "#15744b",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      wrapperMarginInlineEnd: 8,
      dotColorDisabled: "rgba(0, 0, 0, 0.25)",
      buttonSolidCheckedHoverBg: "#2b8058",
      buttonSolidCheckedColor: "#ffffff",
      buttonSolidCheckedBg: "#15744b",
      buttonSolidCheckedActiveBg: "#0a4d32",
      buttonColor: "rgba(0, 0, 0, 0.88)",
      buttonCheckedColorDisabled: "rgba(0, 0, 0, 0.25)",
      buttonCheckedBgDisabled: "rgba(0, 0, 0, 0.15)",
      buttonCheckedBg: "#ffffff",
      buttonBg: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Popover: {
      titleMinWidth: 177,
      sizePopupArrow: 16,
      paddingSM: 12,
      padding: 16,
      marginXS: 8,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSize: 14,
      controlHeight: 32,
      borderRadiusXS: 2,
      borderRadiusLG: 8,
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorBgElevated: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Notification: {
      width: 384,
      paddingMD: 20,
      paddingLG: 24,
      paddingContentHorizontalLG: 24,
      marginXS: 8,
      marginSM: 12,
      marginLG: 24,
      margin: 16,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlHeightLG: 40,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorInfo: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorError: "#ff4d4f",
      colorBgElevated: "#ffffff",
      lineHeightLG: 1.5,
      lineWidthFocus: 4,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Tooltip: {
      paddingSM: 12,
      sizePopupArrow: 16,
      paddingXS: 8,
      lineHeight: 1.5714285714285714,
      fontSize: 14,
      controlHeight: 32,
      borderRadiusXS: 2,
      borderRadius: 6,
      colorTextLightSolid: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorBgSpotlight: "rgba(0, 0, 0, 0.85)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Menu: {
      subMenuItemBg: "rgba(0, 0, 0, 0.02)",
      darkSubMenuItemBg: "#000c17",
      darkItemDisabledColor: "rgba(255, 255, 255, 0.25)",
      darkItemColor: "rgba(255, 255, 255, 0.65)",
      darkGroupTitleColor: "rgba(255, 255, 255, 0.65)",
      darkItemBg: "#001529",
      paddingXS: 8,
      paddingXL: 32,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      margin: 16,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlItemBgActive: "#e9f4ef",
      controlHeightSM: 24,
      controlHeightLG: 40,
      borderRadius: 6,
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorFillContent: "rgba(0, 0, 0, 0.06)",
      colorErrorHover: "#ff7875",
      colorErrorBg: "#fff2f0",
      colorError: "#ff4d4f",
      colorBgElevated: "#ffffff",
      colorBgContainer: "#ffffff",
      subMenuItemBorderRadius: 4,
      popupBg: "#ffffff",
      itemSelectedColor: "#15744b",
      itemSelectedBg: "#e9f4ef",
      itemHoverColor: "rgba(0, 0, 0, 0.88)",
      itemHoverBg: "rgba(0, 0, 0, 0.06)",
      itemHeight: 40,
      itemDisabledColor: "rgba(0, 0, 0, 0.25)",
      itemColor: "rgba(0, 0, 0, 0.88)",
      itemBorderRadius: 8,
      itemBg: "#ffffff",
      iconSize: 14,
      horizontalItemSelectedColor: "#15744b",
      horizontalItemSelectedBg: "rgba(0, 0, 0, 0)",
      horizontalItemHoverColor: "#15744b",
      horizontalItemHoverBg: "rgba(0, 0, 0, 0)",
      groupTitleColor: "rgba(0, 0, 0, 0.45)",
      darkItemSelectedColor: "#ffffff",
      darkItemSelectedBg: "#15744b",
      darkItemHoverColor: "#ffffff",
      darkItemHoverBg: "rgba(0, 0, 0, 0)",
      collapsedIconSize: 16,
      darkPopupBg: "#001529",
      activeBarBorderWidth: 1,
      collapsedWidth: 80,
      dropdownWidth: 160,
      itemMarginBlock: 4,
      itemMarginInline: 4,
      iconMarginInlineEnd: 10,
      groupTitleFontSize: 14,
      groupTitleLineHeight: 1.5714285714285714,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    InputNumber: {
      paddingInlineSM: 7,
      paddingInlineLG: 11,
      paddingInline: 11,
      paddingBlockSM: 0,
      paddingBlockLG: 7,
      paddingBlock: 4,
      handleWidth: 22,
      controlWidth: 90,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      lineWidth: 1,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlPaddingHorizontalSM: 8,
      controlPaddingHorizontal: 12,
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWarningBorderHover: "#ffd666",
      colorWarning: "#faad14",
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimary: "#15744b",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorErrorBorderHover: "#ffa39e",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      hoverBorderColor: "#2b8058",
      handleHoverColor: "#15744b",
      handleBorderColor: "#d9d9d9",
      handleBg: "#ffffff",
      handleActiveBg: "rgba(0, 0, 0, 0.02)",
      addonBg: "rgba(0, 0, 0, 0.02)",
      activeBorderColor: "#15744b",
      activeBg: "#ffffff",
      hoverBg: "#ffffff",
      inputFontSize: 14,
      inputFontSizeLG: 16,
      inputFontSizeSM: 12,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Image: {
      previewOperationSize: 18,
      previewOperationHoverColor: "rgba(255, 255, 255, 0.85)",
      previewOperationColorDisabled: "rgba(255, 255, 255, 0.25)",
      previewOperationColor: "rgba(255, 255, 255, 0.65)",
      paddingXXS: 4,
      paddingSM: 12,
      paddingLG: 24,
      marginXXS: 4,
      marginXL: 32,
      marginSM: 12,
      margin: 16,
      fontSizeIcon: 12,
      controlHeightLG: 40,
      colorTextLightSolid: "#ffffff",
      colorBgMask: "rgba(0, 0, 0, 0.45)",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    },
    Card: {
      headerHeightSM: 38,
      headerHeight: 56,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      lineWidth: 1,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSize: 14,
      borderRadiusLG: 8,
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimary: "#15744b",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorBorderSecondary: "#f0f0f0",
      colorBgContainer: "#ffffff",
      headerBg: "rgba(0, 0, 0, 0.02)",
      headerFontSize: 16,
      headerFontSizeSM: 14,
      fontSizeLG: 16,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Carousel: {
      dotWidth: 16,
      dotHeight: 3,
      dotActiveWidth: 24,
      marginXXS: 4,
      lineHeight: 1.5714285714285714,
      fontSize: 14,
      controlHeightSM: 24,
      controlHeightLG: 40,
      colorText: "rgba(0, 0, 0, 0.88)",
      colorBgContainer: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Cascader: {
      dropdownHeight: 180,
      controlWidth: 184,
      controlItemWidth: 111,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      marginXS: 8,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlInteractiveSize: 16,
      controlHeight: 32,
      borderRadiusSM: 4,
      colorWhite: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      optionSelectedBg: "#e9f4ef",
      menuPadding: 4,
      optionSelectedFontWeight: 600,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Calendar: {
      yearControlWidth: 80,
      monthControlWidth: 70,
      controlHeight: 32,
      screenXS: 480,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeightSM: 1.6666666666666667,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeSM: 12,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlHeightSM: 24,
      controlHeightLG: 40,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      colorTextLightSolid: "#ffffff",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimary: "#15744b",
      colorLinkHover: "#2b8058",
      colorLinkActive: "#0a4d32",
      colorLink: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      itemActiveBg: "#e9f4ef",
      fullPanelBg: "#ffffff",
      fullBg: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Button: {
      paddingInlineSM: 7,
      paddingInlineLG: 15,
      paddingInline: 15,
      onlyIconSizeSM: 14,
      onlyIconSizeLG: 18,
      paddingXS: 8,
      paddingContentHorizontal: 16,
      marginXS: 8,
      lineWidthFocus: 4,
      lineWidth: 1,
      contentLineHeight: 1.5714285714285714,
      contentFontSizeLG: 16,
      contentFontSize: 14,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorTextLightSolid: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimaryActive: "#0a4d32",
      colorPrimary: "#15744b",
      colorLinkHover: "#2b8058",
      colorLinkActive: "#0a4d32",
      colorLink: "#15744b",
      colorErrorOutline: "rgba(255, 38, 6, 0.06)",
      colorErrorHover: "#ff7875",
      colorErrorBorderHover: "#ffa39e",
      colorErrorBg: "#fff2f0",
      colorErrorActive: "#d9363e",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      colorBgTextActive: "rgba(0, 0, 0, 0.15)",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      textHoverBg: "rgba(0, 0, 0, 0.06)",
      primaryColor: "#ffffff",
      onlyIconSize: 16,
      linkHoverBg: "rgba(0, 0, 0, 0)",
      groupBorderColor: "#2b8058",
      ghostBg: "rgba(0, 0, 0, 0)",
      defaultGhostColor: "#ffffff",
      defaultGhostBorderColor: "#ffffff",
      defaultColor: "rgba(0, 0, 0, 0.88)",
      defaultBorderColor: "#d9d9d9",
      defaultBg: "#ffffff",
      dangerColor: "#ffffff",
      borderColorDisabled: "#d9d9d9",
      defaultHoverBg: "#ffffff",
      defaultHoverColor: "#2b8058",
      defaultHoverBorderColor: "#2b8058",
      defaultActiveBg: "#ffffff",
      defaultActiveColor: "#0a4d32",
      defaultActiveBorderColor: "#0a4d32",
      fontWeight: 400,
      contentFontSizeSM: 14,
      contentLineHeightLG: 1.5,
      contentLineHeightSM: 1.5714285714285714,
    },
    Badge: {
      statusSize: 8,
      indicatorHeight: 20,
      dotSize: 6,
      paddingXS: 8,
      marginXS: 8,
      lineWidth: 1,
      borderRadiusSM: 4,
      fontSizeSM: 12,
      fontSize: 14,
      colorWarning: "#faad14",
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextLightSolid: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorPrimary: "#15744b",
      colorErrorHover: "#ff7875",
      colorError: "#ff4d4f",
      colorBorderBg: "#ffffff",
      colorBgContainer: "#ffffff",
      indicatorHeightSM: 14,
      textFontSize: 12,
      textFontSizeSM: 12,
      lineHeight: 1.5714285714285714,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Form: {
      screenXSMax: 575,
      screenSMMax: 767,
      screenMDMax: 991,
      screenLGMax: 1199,
      paddingXS: 8,
      paddingSM: 12,
      marginXXS: 4,
      marginXS: 8,
      marginLG: 24,
      margin: 16,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorPrimary: "#15744b",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      labelRequiredMarkColor: "#ff4d4f",
      labelColor: "rgba(0, 0, 0, 0.88)",
      itemMarginBottom: 24,
      labelColonMarginInlineEnd: 8,
      labelColonMarginInlineStart: 2,
      labelHeight: 32,
      labelFontSize: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Avatar: {
      marginXXS: 4,
      marginXS: 8,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeXL: 20,
      fontSizeLG: 16,
      fontSizeHeading3: 24,
      fontSize: 14,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextLightSolid: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorBorderBg: "#ffffff",
      containerSizeSM: 24,
      containerSizeLG: 40,
      containerSize: 32,
      textFontSize: 18,
      textFontSizeLG: 24,
      textFontSizeSM: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Tour: {
      sizePopupArrow: 16,
      paddingXS: 8,
      padding: 16,
      marginXS: 8,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSize: 14,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWhite: "#ffffff",
      colorTextLightSolid: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimary: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorFill: "rgba(0, 0, 0, 0.15)",
      colorBgTextHover: "rgba(0, 0, 0, 0.06)",
      colorBgElevated: "#ffffff",
      closeBtnSize: 22,
      primaryNextBtnHoverBg: "#f0f0f0",
      primaryPrevBtnBg: "rgba(255, 255, 255, 0.15)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
      lineWidthFocus: 4,
    },
    QRCode: {
      paddingSM: 12,
      marginXS: 8,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSize: 14,
      controlHeight: 32,
      borderRadiusLG: 8,
      colorWhite: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Upload: {
      paddingXS: 8,
      paddingSM: 12,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      marginXL: 32,
      margin: 16,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSizeHeading3: 24,
      fontSizeHeading2: 30,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlHeightLG: 40,
      borderRadiusLG: 8,
      colorTextLightSolid: "#ffffff",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimary: "#15744b",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorErrorBg: "#fff2f0",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      colorBgMask: "rgba(0, 0, 0, 0.45)",
      lineWidthFocus: 4,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Typography: {
      paddingSM: 12,
      marginXXS: 4,
      marginXS: 8,
      lineWidth: 1,
      lineHeightHeading5: 1.5,
      lineHeightHeading4: 1.4,
      lineHeightHeading3: 1.3333333333333333,
      lineHeightHeading2: 1.2666666666666666,
      lineHeightHeading1: 1.2105263157894737,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeHeading5: 16,
      fontSizeHeading4: 20,
      fontSizeHeading3: 24,
      fontSizeHeading2: 30,
      fontSizeHeading1: 38,
      fontSize: 14,
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorLinkHover: "#2b8058",
      colorLinkActive: "#0a4d32",
      colorLink: "#15744b",
      colorErrorHover: "#ff7875",
      colorErrorActive: "#d9363e",
      colorError: "#ff4d4f",
      fontFamilyCode: "Courier Prime",
    },
    TreeSelect: {
      paddingXS: 8,
      marginXXS: 4,
      marginXS: 8,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlInteractiveSize: 16,
      controlHeightSM: 24,
      borderRadiusSM: 4,
      borderRadius: 6,
      colorWhite: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorBorder: "#d9d9d9",
      colorBgElevated: "#ffffff",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      titleHeight: 24,
      nodeSelectedBg: "#e9f4ef",
      nodeHoverBg: "rgba(0, 0, 0, 0.04)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Tree: {
      paddingSM: 12,
      borderRadiusLG: 8,
      paddingXS: 8,
      marginXXS: 4,
      marginXS: 8,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlInteractiveSize: 16,
      controlHeightSM: 24,
      borderRadiusSM: 4,
      borderRadius: 6,
      colorWhite: "#ffffff",
      colorTextLightSolid: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      titleHeight: 24,
      nodeSelectedBg: "#e9f4ef",
      nodeHoverBg: "rgba(0, 0, 0, 0.04)",
      directoryNodeSelectedColor: "#ffffff",
      directoryNodeSelectedBg: "#15744b",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Tag: {
      paddingXXS: 4,
      marginXS: 8,
      lineWidth: 1,
      lineHeightSM: 1.6666666666666667,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSizeIcon: 12,
      fontSize: 14,
      borderRadiusSM: 4,
      colorTextLightSolid: "#ffffff",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryActive: "#0a4d32",
      colorPrimary: "#15744b",
      colorFillTertiary: "rgba(0, 0, 0, 0.04)",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorFillQuaternary: "rgba(0, 0, 0, 0.02)",
      colorBorder: "#d9d9d9",
      colorWarningBorder: "#ffe58f",
      colorWarningBg: "#fffbe6",
      colorSuccessBorder: "#b7eb8f",
      colorSuccessBg: "#f6ffed",
      colorInfoBorder: "#abdbc1",
      colorInfoBg: "#e9f4ef",
      colorErrorBorder: "#ffccc7",
      colorErrorBg: "#fff2f0",
      defaultColor: "rgba(0, 0, 0, 0.88)",
      defaultBg: "rgba(0, 0, 0, 0.02)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Statistic: {
      padding: 16,
      marginXXS: 4,
      lineHeight: 1.5714285714285714,
      fontSizeHeading3: 24,
      fontSize: 14,
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      contentFontSize: 24,
      titleFontSize: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Skeleton: {
      padding: 16,
      marginXXS: 4,
      marginSM: 12,
      marginLG: 24,
      controlHeightXS: 16,
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusSM: 4,
      colorFillContent: "rgba(0, 0, 0, 0.06)",
      colorFill: "rgba(0, 0, 0, 0.15)",
    },
    Select: {
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSize: 14,
      controlPaddingHorizontalSM: 8,
      controlPaddingHorizontal: 12,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlHeightXS: 16,
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWarningOutline: "rgba(255, 215, 5, 0.1)",
      colorWarningHover: "#ffd666",
      colorTextTertiary: "rgba(0, 0, 0, 0.45)",
      colorTextQuaternary: "rgba(0, 0, 0, 0.25)",
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimary: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorErrorOutline: "rgba(255, 38, 6, 0.06)",
      colorErrorHover: "#ff7875",
      colorBorder: "#d9d9d9",
      colorBgElevated: "#ffffff",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      singleItemHeightLG: 40,
      selectorBg: "#ffffff",
      optionSelectedColor: "rgba(0, 0, 0, 0.88)",
      optionSelectedBg: "#e9f4ef",
      optionHeight: 32,
      optionActiveBg: "rgba(0, 0, 0, 0.04)",
      multipleSelectorBgDisabled: "rgba(0, 0, 0, 0.04)",
      multipleItemHeightLG: 32,
      multipleItemHeight: 24,
      multipleItemColorDisabled: "rgba(0, 0, 0, 0.25)",
      multipleItemBorderColorDisabled: "rgba(0, 0, 0, 0)",
      multipleItemBorderColor: "rgba(0, 0, 0, 0)",
      multipleItemBg: "rgba(0, 0, 0, 0.06)",
      clearBg: "#ffffff",
      optionSelectedFontWeight: 600,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Result: {
      paddingXS: 8,
      paddingXL: 32,
      paddingLG: 24,
      padding: 16,
      marginXS: 8,
      lineHeightHeading3: 1.3333333333333333,
      lineHeight: 1.5714285714285714,
      fontSizeHeading3: 24,
      fontSize: 14,
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorSuccess: "#52c41a",
      colorInfo: "#15744b",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorError: "#ff4d4f",
      iconFontSize: 72,
      subtitleFontSize: 14,
      titleFontSize: 24,
    },
    Progress: {
      paddingXS: 8,
      marginXXS: 4,
      marginXS: 8,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSize: 14,
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorFillSecondary: "rgba(0, 0, 0, 0.06)",
      colorError: "#ff4d4f",
      colorBgContainer: "#ffffff",
      remainingColor: "rgba(0, 0, 0, 0.06)",
      defaultColor: "#15744b",
      circleTextColor: "rgba(0, 0, 0, 0.88)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Popconfirm: {
      marginXXS: 4,
      marginXS: 8,
      fontWeightStrong: 600,
      fontSize: 14,
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorText: "rgba(0, 0, 0, 0.88)",
    },
    Pagination: {
      screenSM: 576,
      screenLG: 992,
      paddingXXS: 4,
      paddingSM: 12,
      marginXXS: 4,
      marginXS: 8,
      marginSM: 12,
      margin: 16,
      lineWidthFocus: 4,
      lineWidth: 1,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSize: 14,
      controlPaddingHorizontalSM: 8,
      controlPaddingHorizontal: 12,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlItemBgActiveDisabled: "rgba(0, 0, 0, 0.15)",
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWarningOutline: "rgba(255, 215, 5, 0.1)",
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorErrorOutline: "rgba(255, 38, 6, 0.06)",
      colorBorder: "#d9d9d9",
      colorBgTextHover: "rgba(0, 0, 0, 0.06)",
      colorBgTextActive: "rgba(0, 0, 0, 0.15)",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      itemSizeSM: 24,
      itemSize: 32,
      itemLinkBg: "#ffffff",
      itemInputBg: "#ffffff",
      itemBg: "#ffffff",
      itemActiveColorDisabled: "rgba(0, 0, 0, 0.25)",
      itemActiveBgDisabled: "rgba(0, 0, 0, 0.15)",
      itemActiveBg: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Modal: {
      screenSMMax: 767,
      paddingXS: 8,
      paddingMD: 20,
      paddingLG: 24,
      paddingContentHorizontalLG: 24,
      padding: 16,
      marginXS: 8,
      marginSM: 12,
      marginLG: 24,
      margin: 16,
      lineWidthFocus: 4,
      lineWidth: 1,
      lineHeightHeading5: 1.5,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeLG: 16,
      fontSizeHeading5: 16,
      fontSize: 14,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorPrimaryBorder: "#abdbc1",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorBgMask: "rgba(0, 0, 0, 0.45)",
      titleColor: "rgba(0, 0, 0, 0.88)",
      headerBg: "#ffffff",
      footerBg: "rgba(0, 0, 0, 0)",
      contentBg: "#ffffff",
      titleFontSize: 16,
      titleLineHeight: 1.375,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Message: {
      paddingXS: 8,
      paddingSM: 12,
      marginXS: 8,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlHeightLG: 40,
      borderRadiusLG: 8,
      colorWarning: "#faad14",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccess: "#52c41a",
      colorInfo: "#15744b",
      colorError: "#ff4d4f",
      contentBg: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    List: {
      screenSM: 576,
      screenMD: 768,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      paddingContentVerticalSM: 8,
      paddingContentVerticalLG: 16,
      paddingContentVertical: 12,
      paddingContentHorizontalLG: 24,
      paddingContentHorizontal: 16,
      padding: 16,
      marginXXS: 4,
      marginXXL: 48,
      marginSM: 12,
      marginLG: 24,
      margin: 16,
      lineWidth: 1,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSize: 14,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusLG: 8,
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimary: "#15744b",
      colorBorder: "#d9d9d9",
      headerBg: "rgba(0, 0, 0, 0)",
      footerBg: "rgba(0, 0, 0, 0)",
      avatarMarginRight: 16,
      descriptionFontSize: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    FloatButton: {
      paddingXXS: 4,
      marginXXL: 48,
      marginLG: 24,
      margin: 16,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSize: 14,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlHeightLG: 40,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      colorTextLightSolid: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimaryHover: "#2b8058",
      colorPrimary: "#15744b",
      colorFillContent: "rgba(0, 0, 0, 0.06)",
      colorBgElevated: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Empty: {
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      fontSize: 14,
      lineHeight: 1.5714285714285714,
    },
    Dropdown: {
      sizePopupArrow: 16,
      paddingXXS: 4,
      paddingXS: 8,
      marginXXS: 4,
      marginXS: 8,
      lineWidthFocus: 4,
      lineHeight: 1.5714285714285714,
      fontSizeSM: 12,
      fontSizeIcon: 12,
      fontSize: 14,
      controlPaddingHorizontal: 12,
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActiveHover: "#dae8e0",
      controlItemBgActive: "#e9f4ef",
      controlHeight: 32,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      colorTextLightSolid: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorError: "#ff4d4f",
      colorBgElevated: "#ffffff",
      paddingBlock: 5,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Drawer: {
      paddingXS: 8,
      paddingLG: 24,
      padding: 16,
      marginSM: 12,
      lineWidth: 1,
      lineHeightLG: 1.5,
      fontWeightStrong: 600,
      fontSizeLG: 16,
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorBgMask: "rgba(0, 0, 0, 0.45)",
      colorBgElevated: "#ffffff",
      lineWidthFocus: 4,
    },
    Divider: {
      marginXS: 8,
      marginLG: 24,
      margin: 16,
      lineWidth: 1,
      fontSizeLG: 16,
      fontSize: 14,
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      lineHeight: 1.5714285714285714,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Descriptions: {
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      lineWidth: 1,
      lineHeightSM: 1.6666666666666667,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeSM: 12,
      fontSizeLG: 16,
      fontSize: 14,
      borderRadiusLG: 8,
      colorTextTertiary: "rgba(0, 0, 0, 0.45)",
      colorTextSecondary: "rgba(0, 0, 0, 0.65)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      titleColor: "rgba(0, 0, 0, 0.88)",
      labelBg: "rgba(0, 0, 0, 0.02)",
      contentColor: "rgba(0, 0, 0, 0.88)",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    DatePicker: {
      sizePopupArrow: 16,
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      padding: 16,
      marginXXS: 4,
      marginXS: 8,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeightLG: 1.5,
      lineHeight: 1.5714285714285714,
      fontWeightStrong: 600,
      fontSizeLG: 16,
      fontSize: 14,
      controlPaddingHorizontalSM: 8,
      controlPaddingHorizontal: 12,
      controlOutlineWidth: 2,
      controlOutline: "rgba(5, 145, 255, 0.1)",
      controlItemBgHover: "rgba(0, 0, 0, 0.04)",
      controlItemBgActive: "#e9f4ef",
      controlHeightSM: 24,
      controlHeightLG: 40,
      controlHeight: 32,
      borderRadiusXS: 2,
      borderRadiusSM: 4,
      borderRadiusLG: 8,
      borderRadius: 6,
      colorWarningOutline: "rgba(255, 215, 5, 0.1)",
      colorWarningHover: "#ffd666",
      colorWarning: "#faad14",
      colorTextQuaternary: "rgba(0, 0, 0, 0.25)",
      colorTextPlaceholder: "rgba(0, 0, 0, 0.25)",
      colorTextLightSolid: "#ffffff",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorTextDescription: "rgba(0, 0, 0, 0.45)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorLinkHover: "#2b8058",
      colorLinkActive: "#0a4d32",
      colorLink: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorErrorOutline: "rgba(255, 38, 6, 0.06)",
      colorErrorHover: "#ff7875",
      colorError: "#ff4d4f",
      colorBorder: "#d9d9d9",
      colorBgElevated: "#ffffff",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      hoverBorderColor: "#2b8058",
      cellHoverBg: "rgba(0, 0, 0, 0.04)",
      cellHeight: 24,
      activeBorderColor: "#15744b",
      paddingInline: 11,
      paddingInlineSM: 7,
      colorFillTertiary: "rgba(0, 0, 0, 0.04)",
      colorErrorBg: "#fff2f0",
      colorWarningBg: "#fffbe6",
      colorWarningText: "#faad14",
      colorErrorText: "#ff4d4f",
      colorWarningBgHover: "#fff1b8",
      colorErrorBgHover: "#fff1f0",
      activeBg: "#ffffff",
      hoverBg: "#ffffff",
      cellBgDisabled: "rgba(0, 0, 0, 0.04)",
      cellActiveWithRangeBg: "#e9f4ef",
      cellHoverWithRangeBg: "#c8dfff",
      cellRangeBorderColor: "#7cb3ff",
      multipleItemBg: "rgba(0, 0, 0, 0.06)",
      multipleItemBorderColor: "rgba(0, 0, 0, 0)",
      multipleItemBorderColorDisabled: "rgba(0, 0, 0, 0)",
      multipleItemColorDisabled: "rgba(0, 0, 0, 0.25)",
      multipleSelectorBgDisabled: "rgba(0, 0, 0, 0.04)",
      cellWidth: 36,
      multipleItemHeight: 24,
      multipleItemHeightLG: 32,
      multipleItemHeightSM: 16,
      paddingBlock: 4,
      paddingBlockLG: 7,
      paddingBlockSM: 0,
      presetsMaxWidth: 200,
      presetsWidth: 120,
      textHeight: 40,
      timeCellHeight: 28,
      timeColumnHeight: 224,
      timeColumnWidth: 56,
      withoutTimeCellHeight: 66,
      inputFontSize: 14,
      inputFontSizeLG: 16,
      inputFontSizeSM: 12,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Collapse: {
      paddingXXS: 4,
      paddingXS: 8,
      paddingSM: 12,
      paddingLG: 24,
      padding: 16,
      marginSM: 12,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSize: 14,
      borderRadiusLG: 8,
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorFillAlter: "rgba(0, 0, 0, 0.02)",
      colorBorder: "#d9d9d9",
      colorBgContainer: "#ffffff",
      headerBg: "rgba(0, 0, 0, 0.02)",
      contentBg: "#ffffff",
      lineHeightLG: 1.5,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Checkbox: {
      paddingXS: 8,
      marginXS: 8,
      lineWidthFocus: 4,
      lineWidthBold: 2,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      controlInteractiveSize: 16,
      borderRadiusSM: 4,
      colorWhite: "#ffffff",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorPrimaryHover: "#2b8058",
      colorPrimaryBorder: "#abdbc1",
      colorPrimary: "#15744b",
      colorBorder: "#d9d9d9",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorBgContainer: "#ffffff",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Breadcrumb: {
      paddingXXS: 4,
      marginXXS: 4,
      marginXS: 8,
      lineWidthFocus: 4,
      lineHeight: 1.5714285714285714,
      fontSizeIcon: 12,
      fontSize: 14,
      borderRadiusSM: 4,
      colorPrimaryBorder: "#abdbc1",
      colorBgTextHover: "rgba(0, 0, 0, 0.06)",
      separatorColor: "rgba(0, 0, 0, 0.45)",
      linkHoverColor: "rgba(0, 0, 0, 0.88)",
      linkColor: "rgba(0, 0, 0, 0.45)",
      lastItemColor: "rgba(0, 0, 0, 0.88)",
      itemColor: "rgba(0, 0, 0, 0.45)",
      separatorMargin: 8,
      iconFontSize: 14,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Anchor: {
      paddingXXS: 4,
      lineWidthBold: 2,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSize: 14,
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSplit: "rgba(0, 0, 0, 0.06)",
      colorPrimary: "#15744b",
      linkPaddingInlineStart: 16,
      linkPaddingBlock: 4,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Alert: {
      paddingMD: 20,
      paddingContentVerticalSM: 8,
      paddingContentHorizontalLG: 24,
      marginXS: 8,
      marginSM: 12,
      lineWidth: 1,
      lineHeight: 1.5714285714285714,
      fontSizeLG: 16,
      fontSizeIcon: 12,
      fontSizeHeading3: 24,
      fontSize: 14,
      borderRadiusLG: 8,
      colorWarningBorder: "#ffe58f",
      colorWarningBg: "#fffbe6",
      colorWarning: "#faad14",
      colorTextHeading: "rgba(0, 0, 0, 0.88)",
      colorText: "rgba(0, 0, 0, 0.88)",
      colorSuccessBorder: "#b7eb8f",
      colorSuccessBg: "#f6ffed",
      colorSuccess: "#52c41a",
      colorInfoBorder: "#abdbc1",
      colorInfoBg: "#e9f4ef",
      colorInfo: "#15744b",
      colorIconHover: "rgba(0, 0, 0, 0.88)",
      colorIcon: "rgba(0, 0, 0, 0.45)",
      colorErrorBorder: "#ffccc7",
      colorErrorBg: "#fff2f0",
      colorError: "#ff4d4f",
      withDescriptionIconSize: 24,
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
    },
    Space: {
      paddingXS: 8,
      paddingLG: 24,
      padding: 16,
    },
    Layout: {
      bodyBg: "#f5f5f5",
      footerBg: "#f5f5f5",
      headerBg: "#001529",
      headerColor: "rgba(0, 0, 0, 0.88)",
      lightSiderBg: "#ffffff",
      lightTriggerBg: "#ffffff",
      lightTriggerColor: "rgba(0, 0, 0, 0.88)",
      siderBg: "#001529",
      triggerBg: "#002140",
      triggerColor: "#ffffff",
      colorText: "rgba(0, 0, 0, 0.88)",
      headerHeight: 64,
      triggerHeight: 48,
      zeroTriggerHeight: 40,
      zeroTriggerWidth: 40,
      borderRadius: 6,
      fontSize: 14,
      fontSizeXL: 20,
    },
    Mentions: {
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif;",
      fontSize: 14,
      lineHeight: 1.5714285714285714,
    },
  },
};
